
import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { resetStates } from "../../../actions/Common";
import { getMasterHealthPlan } from "../../../actions/Master";
import { checkEligibility } from "../../../actions/Patient";
import { EligibilityCheck } from "../../../models/Patient";
import { getListResult } from "../../../utils";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";
import { TabData } from "../../../models/TabSessionStorage";
import { saveTabSessionStorageResp } from "../../../actions/TabSessionStorage";
import AuthorizationForm from "../components/AuthorizationForm";

const mapStateToProps = ({
  healthPlanState,
  checkEligibilityState,
  tabSessionStorageState,
  memberInfoDataState,
  patientInformationByIdState,
  loggedInUserState,
}: ApplicationState) => ({
  healthPlanState: getListResult(healthPlanState.response),
  checkEligibilityState: checkEligibilityState.response,
  tabSessionStorage: tabSessionStorageState,
  memberInfoDataState: memberInfoDataState.response,
  patientInformationByIdState: patientInformationByIdState.response,
  loggedInUserState: loggedInUserState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    saveTabSessionStorage: (sessionData: TabData) => {
      dispatch(saveTabSessionStorageResp(sessionData));
    },
    resetStates: (actionType: string, field?: string) => {
      dispatch(resetStates(actionType, field));
    },
    getMasterHealthPlan: () => {
      dispatch(getMasterHealthPlan());
    },
    checkEligibility: (payload: EligibilityCheck) => {
      dispatch(checkEligibility(payload));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AuthorizationForm);
